import { updateComponent } from '../../../redux/editorSlice';
import { extractValueAndUnit } from './styleUtils';

// 디바이스별 스타일 강제 적용
export const ensureDeviceStylesApplied = (selectedComponent, boardDeviceTab, forceApply = false) => {
  if (!selectedComponent) return;
  
  return (dispatch) => {
    try {
      // 디바이스별 스타일 강제 적용
      applyBoardStylesWithFallback(selectedComponent, boardDeviceTab, forceApply, dispatch);
    } catch (error) {
      console.error("[보드 스타일] 스타일 적용 중 오류 발생:", error);
    }
  };
};

// 안전하게 스타일을 적용하는 함수
export const applyBoardStylesWithFallback = (selectedComponent, boardDeviceTab, forceApply = false, dispatch) => {
  try {
    if (!selectedComponent) return;

    // 현재 선택된 컴포넌트의 스타일 객체 (깊은 복사)
    const currentStyle = { ...(selectedComponent.style || {}) };

    // 디바이스별 스타일 초기화 (필요시)
    if (!currentStyle.device) {
      currentStyle.device = { pc: {}, mobile: {} };

      // 기존 스타일 속성을 디바이스별로 복사
      ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 
       'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 
       'borderRadius'].forEach(key => {
        if (currentStyle[key] !== undefined) {
          currentStyle.device.pc[key] = currentStyle[key];
          currentStyle.device.mobile[key] = currentStyle[key];
        }
      });
    }

    // 디바이스별 스타일 데이터 가져오기 (안전하게)
    const deviceStyles = currentStyle.device && currentStyle.device[boardDeviceTab] 
      ? { ...currentStyle.device[boardDeviceTab] } 
      : {};

    // 적용할 스타일 객체
    const paddingStyles = {};
    let hasChanges = false;

    // 패딩 스타일 적용
    const styleKeys = [
      'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft',
      'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft'
    ];

    styleKeys.forEach(key => {
      if (deviceStyles[key] || forceApply) {
        // 강제 적용 모드이거나 기존 값이 있는 경우
        paddingStyles[key] = deviceStyles[key] || currentStyle[key] || '0px';

        // 최상위 스타일에도 동일하게 적용 (즉각적인 반영을 위해)
        currentStyle[key] = paddingStyles[key];
        hasChanges = true;
      }
    });

    // 테두리 둥글기 적용
    if (deviceStyles.borderRadius || forceApply) {
      paddingStyles.borderRadius = deviceStyles.borderRadius || currentStyle.borderRadius || '0px';
      currentStyle.borderRadius = paddingStyles.borderRadius;
      hasChanges = true;
    }

    // 변경사항이 있거나 강제 적용 모드인 경우 업데이트
    if (hasChanges || forceApply) {
      // 스타일 업데이트 - 새로운 객체 생성으로 확실한 참조 변경
      const updatedStyle = JSON.parse(JSON.stringify(currentStyle));

      // 디스패치
      dispatch(updateComponent({
        id: selectedComponent.id,
        changes: {
          style: updatedStyle
        }
      }));
      
      return true;
    }
    
    return false;
  } catch (error) {
    console.error("[보드 스타일] 폴백 적용 중 오류:", error);
    return false;
  }
};

// 디바이스 타입에 맞는 속성값 로드 함수
export const loadDeviceSpecificProperties = (selectedComponent, deviceType, setPaddingInputs, setBorderRadiusInput) => {
  // 선택된 컴포넌트가 없으면 리턴
  if (!selectedComponent) return;
  
  // 스타일 로드
  if (selectedComponent.style?.deviceProperty?.[deviceType]) {
    // 패딩 입력값 초기화
    const deviceStyle = selectedComponent.style.deviceProperty[deviceType];
    
    // 패딩 값 설정
    setPaddingInputs({
      top: extractValueAndUnit(deviceStyle.paddingTop || selectedComponent.style?.paddingTop || '0px').value.toString(),
      right: extractValueAndUnit(deviceStyle.paddingRight || selectedComponent.style?.paddingRight || '0px').value.toString(),
      bottom: extractValueAndUnit(deviceStyle.paddingBottom || selectedComponent.style?.paddingBottom || '0px').value.toString(),
      left: extractValueAndUnit(deviceStyle.paddingLeft || selectedComponent.style?.paddingLeft || '0px').value.toString()
    });
    
    // 테두리 둥글기 설정
    setBorderRadiusInput(
      extractValueAndUnit(deviceStyle.borderRadius || selectedComponent.style?.borderRadius || '0px').value.toString()
    );
  } else {
    // 해당 디바이스 타입의 속성이 없으면 기본 값 사용
    setPaddingInputs({
      top: extractValueAndUnit(selectedComponent.style?.paddingTop || '0px').value.toString(),
      right: extractValueAndUnit(selectedComponent.style?.paddingRight || '0px').value.toString(),
      bottom: extractValueAndUnit(selectedComponent.style?.paddingBottom || '0px').value.toString(),
      left: extractValueAndUnit(selectedComponent.style?.paddingLeft || '0px').value.toString()
    });
    
    setBorderRadiusInput(
      extractValueAndUnit(selectedComponent.style?.borderRadius || '0px').value.toString()
    );
  }
}; 